var cls = 'active';
var scale = 0.6;
var activeItem = 0;
var autoplaySpeed = 6000;
var dashboardInteration = false;

function desktop(options) {
  var nav = options.current.querySelector(options.selector+'-desktop_nav .flex_container ul');
  var media = options.current.querySelector(options.selector+'-desktop_display '+options.selector+'-desktop_media_slider');

  function animationLogic(index) {
    var newActiveItem = index;

    if (activeItem !== newActiveItem) {
      nav.querySelector('.'+cls).classList.remove(cls);
      nav.querySelector('[data-index="'+newActiveItem+'"]').classList.add(cls);
    }

    hideMedia(activeItem);
    activeItem = newActiveItem;
    showMedia(activeItem);

  }

  function autoplay() {
    var dataIndex = 0;
    var li = Array.from(nav.children);
    var totalLi = li.length;

    var variableCheck = setInterval(function() {

      if (dataIndex == (totalLi - 1)) {
        dataIndex = 0;
      } else {
        dataIndex++;
      }

      
      if (dashboardInteration === true) {
        clearInterval(variableCheck)
      } else {
        animationLogic(dataIndex);
      }
    }, autoplaySpeed);
  }

  function hideMedia(index) {
    TweenLite.set(media.querySelector('[data-index="'+index+'"]'), {
      zIndex: 0,
    });
    TweenLite.to(media.querySelector('[data-index="'+index+'"]'), 0.35, {
      display: 'none',
      scale: scale,
      autoAlpha: 0,
      ease: Power3.easeOut,
    });
  };

  function showMedia(index) {
    TweenLite.set(media.querySelector('[data-index="'+index+'"]'), {
      zIndex: 1,
    });
    TweenLite.to(media.querySelector('[data-index="'+index+'"]'), 0.35, {
      display: 'block',
      scale: 1,
      autoAlpha: 1,
      ease: Power3.easeOut,
    });
  };

  function navInit() {
    var li = Array.from(nav.children);

    li.forEach(function(item) {
      item.querySelector('button').addEventListener('click', function() {
        dashboardInteration = true;
        var index = this.parentNode.getAttribute('data-index');
        animationLogic(index);
      });
    })
  };

  function setDefault() {
    var navLi = nav.children;
    var mediaImage = media.children;
    var firstNavLi = navLi[0];
    var firstMediaImage = mediaImage[0];

    
    // set aspect ratio
    function setContainerStyles() {
      TweenLite.set(media, {
        paddingTop: function() {
          var aspect = 9/14;
          return aspect * 100 + '%';
        },
        position: 'relative',
        onComplete: function() {
          firstNavLi.classList.add(cls);
          firstMediaImage.classList.add(cls);
        },
      });
    };

    // set item styles
    function setCildStyles() {
      Array.from(mediaImage).forEach(function(image, index) {
        var styles = {
          position: 'absolute',
          top: 0,
          left: 0,
        };
  
        if (index !== 0) {
          styles.visibility = 'hidden';
          styles.opacity = '0';
          styles.scale = scale;
        }
  
        TweenLite.set(image, styles);
      });
    };

    setContainerStyles();
    setCildStyles();
  };

  setDefault();
  navInit();
  autoplay();
}

function mobile(options) {
  var nav = options.current.querySelector(options.selector+'-mobile_nav .flex_container ul');
  var media = options.current.querySelector(options.selector+'-mobile_display .flex_container');
  var buttons = nav.querySelectorAll('button');

  $(nav).slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    variableWidth: true,
    mobileFirst: true,
    asNavFor: media,
  });

  $(media).slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    adaptiveHeight: true,
    fade: true,
  });

  buttons.forEach(function(button) {
    button.addEventListener('click', function() {
      buttons = nav.querySelectorAll('button');

      var clickedIndex = this.parentNode.getAttribute('data-index');
      $(nav).slick('slickGoTo', clickedIndex);
      $(media).slick('slickGoTo', clickedIndex);
    });
  })
};

document.addEventListener('DOMContentLoaded', function() {
  var selector = '.dashboard_display';
  var components = document.querySelectorAll(selector);

  components.forEach(function (component) {

    var config = {
      all: components,
      current: component,
      selector: selector,
    };

    mobile(config);
    desktop(config);

  });
});